/**
 * Dependencies
 */
import Launcher from '../../requests/apa/Launcher';
import Metadata from '../../requests/apa/Metadata';
import getAppConfig from '../../config/appConfig';
import RequestManager from '../../requests/RequestManager';
import SimplePostRequestTask from '../../requests/tasks/SimplePostRequestTask';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import pkg from '../../../package.json';
import { AAF_CONTENT_IS_AUDIO } from '../../AAFPlayer/constants';
import Utils from '../Utils';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import AAF from "../../AAF/AAF";
import { EPG_VERSION_TTL} from '../../AAF/Resilence/TTLConstants';
import logger from 'src/utils/logger/logger';

const TTLItem = EPG_VERSION_TTL;
const LOGS_DASHBOARD_URL = Metadata.get('logs_dashboard_url'); // 'http://dashboard-producer.clarovideo.net/send'

/**
 * Se usa para el logging de las actividades del usuario (SumoLogic):
 *
 - Reproducción VOD:
 Llamada de PGM (pgm)
 inicio (start)
 fin (end)
 pausa (pause)
 stop (stop)
 error (error)
 buffering (buffering)
 seek (seek)
 Cambio de calidad (quality_up, quality_down)
 Cambio de idioma (language)
 Cambio de capítulo (episode)

 - Reproducción Live:
 Llamada de PGM(live_pgm)
 inicio (live_start)
 pausa (live_pause)
 error (live_error)
 stop (live_stop)
 buffering (live_buffering)
 Cambio de calidad (live_quality_up, live_quality_down)
 *
 */

const PGM = 'pgm';
const START = 'buffering_start';
const PLAY = 'start';
const END = 'End';
const BUFFERINGEND = 'buffering_end';
const PAUSE = 'Pause';
const STOP = 'Stop';
const ERROR = 'error';
const BUFFERING = 'buffering_start';
const SEEK = 'seek';
const QUALITY_UP = 'quality_up';
const LANGUAGE = 'Language';
const EPISODE = 'episode';
const RESUME = 'Resume';
const LEAVE = 'leave';
const LEAVE_APP = 'leave';
const FOWARD = 'Foward'; // NOT included on de documentation  there is more than a lager live
const REWIND = 'Rewind'; //
const FOWARD30 = 'Forward30';
const REWIND30 = 'Rewind30';

const LIVE_ERROR = 'live_error';
const VOD_ERROR = 'vod_error';
const PLAYING_FALLBACK = 'playing_fallback';
const FALLBACK_ERROR = 'fallback_error';
const START_PLAY_FALLED = 'start_play_falled';
const API_ERROR = 'api_error';
const APPLICATION_PARAMS = {
  platform: 'aaf',
  version: pkg.version
};

const config = getAppConfig();
const ip = Launcher.get('ipNetworkPublicAddress');
const DEVICE_PARAMS = {
  ip,
  kind: config.device_category,
  brand: config.device_manufacturer,
  model: config.device_model,
  os: config.device_so,
  deviceid: config.device_id,
  device_type: config.device_type,
  device_name: config.device_name
};

class DashboardTracker {
  static groupId = null;

  static currentStreamContentType = null;

  constructor() {
    this.flag = false;
    this.getmediaCounter = 0;
    this.lastEvent = null;
    this.name = 'dashboard';
    this.headers = {
      Pragma: `akamai-x-cache-on, akamai-x-cache-remote-on, akamai-x-check-cacheable, akamai-x-get-cache-key, akamai-x-get-extracted-values, akamai-x-get-nonces, akamai-x-get-ssl-client-session-id, akamai-x-get-true-cache-key, akamai-x-serial-no, akamai-x-get-request-id`
    };
  }

  setup(pgm = {}, extraParams = {}, streamContentType = null) {
    logger.debug('setup DashboardTracker');
    if (pgm && pgm.response && pgm.response.group && pgm.response.group.common) {
      DashboardTracker.groupId = pgm.response.group.common.id;
      DashboardTracker.content_id = pgm.entry.content_id ? pgm.entry.content_id : '';
      DashboardTracker.video_url = pgm.response.media.video_url
        ? pgm.response.media.video_url
        : '';
      DashboardTracker.stream_type = pgm.entry.stream_type ? pgm.entry.stream_type : '';
      DashboardTracker.pgmResponse = pgm.response;

      if(pgm && pgm.response && pgm.response.language && pgm.response.language.options) {
        DashboardTracker.language = this.getLanguage(pgm.response.language.options);
      }
      else {
        DashboardTracker.language = '';
      }

      if (
        pgm.response.group.common.extendedcommon &&
        pgm.response.group.common.extendedcommon.media
      ) {
        DashboardTracker.isLive =
          pgm.response.group.common.extendedcommon.media.islive == '1';
      }
    }
    if (pgm && pgm.response && pgm.response.media && pgm.response.media.analytics_url) {
      DashboardTracker.servername = pgm.response.media.analytics_url || 'default';
    }

    // Reset stream anterior
    if (DashboardTracker.currentStreamContentType !== null) {
      this.setCurrentStreamContentType(null);
    }

    // Update stream content type
    if (streamContentType !== null) {
        this.setCurrentStreamContentType(streamContentType);
    }

  }


  setCurrentStreamContentType(streamContentType) {
    DashboardTracker.currentStreamContentType = streamContentType;
  }

  pgm(data = null) {
    logger.debug('[DashboardTracker] pgm');
    if (data) {
      const content = {};
      content.msg = JSON.stringify(data.errors[0]);
      content.stackTrace = JSON.stringify(data.errors[0]);
      content.url = data.url;
      this.checkLastEvent(PGM) && this.track(PGM, 0, content);
    } else {
      this.checkLastEvent(PGM) && this.track(PGM);
    }
  }

  static isAudio() {
    if (DashboardTracker.currentStreamContentType === null) {
        return false;
    }

    let isAudioStream = false;
    switch (DashboardTracker.currentStreamContentType) {
        case AAF_CONTENT_IS_AUDIO:
            isAudioStream = true;
            break;
        default:
            break;
    }

    return isAudioStream;
  }

  playing() {
    logger.debug('DashboardTracker playing');
    this.checkLastEvent(PLAY) && this.track(PLAY);
  }

  play() {
    // Se da click en play
    // Se comenta para evitar duplicidad
    // console.log("01DashboardTracker play");
    // this.track(PLAY);
  }

  credits() {
    // El evento END de dashboard se debe de enviar en el finPlayer por eso se pude en credist
    logger.debug('[DashboardTracker] end');
    this.checkLastEvent(END) && this.track(END);
  }

  pause() {
    logger.debug('[DashboardTracker] pause');
    this.checkLastEvent(PAUSE) && this.track(PAUSE);
  }

  stop() {
    logger.debug('[DashboardTracker] stop');
    this.checkLastEvent(STOP) && this.track(STOP);
  }

  error(content) {
    if (DashboardTracker.isAudio()) return;
    logger.debug('[DashboardTracker] error');
    this.track(ERROR, 0, content);
  }

  errorContent(content) {
    logger.debug('DashboardTracker vod_error');
    this.track(VOD_ERROR, 0, content);
  }

  errorLive(content) {
    logger.debug('DashboardTracker live_error');
    this.track(LIVE_ERROR, 0, content);
  }

  apiError(content) {
    logger.debug('DashboardTracker api_error', content.stackTrace);
    this.track(API_ERROR, 0, content);
  }

  foward() {
    logger.debug("DashboardTracker foward with the player's bar controls");
    this.track(FOWARD);
  }

  rewind() {
    logger.debug('DashboardTracker rewind with the player back control');
    this.track(REWIND);
  }

  foward30() {
    logger.debug('DashboardTracker foward 30 seconds');
    this.track(FOWARD30);
  }

  rewind30() {
    logger.debug('DashboardTracker rewind 30 seconds');
    this.track(REWIND30);
  }

  bufferStart() {
    logger.debug('[DashboardTracker] buffer start');
    this.track(BUFFERING);
  }

  bufferEnd() {
    logger.debug('DashboardTracker buffer end');
    this.track(BUFFERINGEND);
  }

  seek(seek) {
    logger.debug('[DashboardTracker] seek: ', seek);
    this.track(SEEK, null, null, seek);
  }

  // bitRateChange(currentTime, diff) {
  //   // TODO: saber que parametro usar para saber si es quiality up o quality down
  //   this.track(QUALITY_UP);

  //   this.track(QUALITY_DOWN);
  // }

  audioChange() {
    logger.debug('[DashboardTracker] audioChange');
    this.track(LANGUAGE);
  }

  episodeChange() {
    logger.debug('[DashboardTracker] episode');
    this.track(EPISODE);
  }

  getTime() {
    logger.debug('[DashboardTracker] getTime');
    return EpgPersistence.needsOffset() ?
    `${Utils.now(true).utcOffset(EpgPersistence.needsOffset(),false).format('YYYY-MM-DD')}T${Utils.now(true).utcOffset(EpgPersistence.needsOffset(),false).format('HH:MM:ss.SSS')}z`:
    `${Utils.now(true).format('YYYY-MM-DD')}T${Utils.now(true).format('HH:MM:ss.SSS')}z`
  }

  qualityUp() {
    logger.debug('DashboardTracker get quality Up');
    this.checkLastEvent(QUALITY_UP) && this.track(QUALITY_UP);
  }

  getUser() {
    logger.debug('[DashboardTracker] getUser');
    const { user } = store.getState();
    if (user.isLoggedIn) {
      return {
        username: user.username,
        userid: user.user_id,
        hks: user.session_stringvalue,
        userhash: user.session_userhash,
        email: user.email,
        suscription: user.isSusc ? 1 : 0,
        region: user.region
      };
    }

    return this.getAnonymousUser();
  }

  getAnonymousUser() {
    logger.debug('[DashboardTracker] getAnonymusUser');
    return {
      username: `anonymous`,
      userid: '0',
      hks: DeviceStorage.getItem('HKS'),
      userhash: DeviceStorage.getItem('user_hash'),
      email: 'anonymous',
      suscription: 0,
      region: DeviceStorage.getItem('region')
    };
  }

  getServerName() {
    logger.debug('[DashboardTracker] getServerName');
    const { user } = store.getState();
    return user.session_servername;
  }

  getCdn() {
    logger.debug('[DashboardTracker] getCdn');
    const headers = window.headersPGM;
    return {
      node: headers && headers.node ? headers.node : '',
      'X-Cache': headers && headers['X-Cache'] ? headers['X-Cache'] : '',
      'X-Cache-Remote': headers && headers['X-Cache-Remote'] ? headers['X-Cache-Remote'] : '',
      'X-Cache-Key': headers && headers['X-Cache-Key'] ? headers['X-Cache-Key'] : '',
      'X-Cache-ID': headers && headers['X-Cache-ID'] ? headers['X-Cache-ID'] : '',
      URL: headers && headers.URL ? headers.URL : ''
    };
  }

  leaveContent() {
    logger.debug('DashboardTracker leave');
    this.track(LEAVE);
  }

  leaveApp() {
    logger.debug('DashboardTracker leave app');
    this.track(LEAVE_APP);
  }

  resume() {
    logger.debug('DashboardTracker resume');
    this.track(RESUME);
  }

  start() {
    logger.debug('DashboardTracker start');
    this.track(START);
  }

  fallbackError(msg, err, url) {
    if(url){
      DashboardTracker.video_url = url;
    }
    if(msg){
      DashboardTracker.stream_type = msg;
    }
    let response = "";
    if(err){
      response = err;
    }
    this.track(FALLBACK_ERROR, 1, { stackTrace: 'error', msg, response  });
  }

  playingFallback(msg, err) {
    let response = "";
    if(err){
      response = err;
    }
    this.track(PLAYING_FALLBACK, 1, { stackTrace: 'fallback', msg, response  });
  }

  startPlayFalled() {
    this.track(START_PLAY_FALLED);
  }

  // Revisa si este evento ya ha sido enviado,
  // de ser asi regresa false
  checkLastEvent(event) {
    if (this.lastEvent === event) {
      return false;
    }

    this.lastEvent = event;
    return true;
  }

  getOperatorEpg = (
    operatorKey,
    { status, content = null, epgVersion, soaVersion, subRegion }
  ) => ({
    operatorKey,
    status, // 1 exito, 0 fallo
    msg: content ? content.msg : '', // Mensaje.
    stacktrace: content ? content.stackTrace : '', // stacktrace
    response: '',
    request: '',
    sub_region: subRegion,
    epg_version: epgVersion,
    soa_version: soaVersion
  });

  getOperator = (
    operatorKey,
    { status, content = null, seek, epgVersion, soaVersion, subRegion }
  ) => {
    let operator = {
      sub_region: subRegion,
      epg_version: epgVersion,
      soa_version: soaVersion,
      groupid: DashboardTracker.groupId,
      contentid: DashboardTracker.content_id ? DashboardTracker.content_id : '',
      video_url: DashboardTracker.video_url ? DashboardTracker.video_url : '',
      stream_type: DashboardTracker.stream_type ? DashboardTracker.stream_type : '',
      operatorKey,
      status, // 1 exito, 0 fallo
      // faildata: {
      msg: content ? content.msg : '', // Mensaje de error. Si PGM no response por un error de red aquí se indica el mensaje correspondiente, p.j "DNS exception", "Timeout exception", etc
      stacktrace: content ? content.stackTrace : '', // stacktrace en caso de haberse generado en el device,
      response:
        operatorKey === API_ERROR
          ? this.pgmResponse
            ? this.pgmResponse
            : ''
          : operatorKey === ERROR || operatorKey === LIVE_ERROR
            ? (content && content.message && content.message.stackTrace) || ''
            : content && content.response? content.response : '', // Únicamente para PGM. Si PGM no responde por un error de red el valor no se envía. Para los demás eventos no se envía este valor.
      request: content && content.url ? content.url : '', // Únicamente para PGM. Para los demás eventos no se envía este valor.
      language: DashboardTracker.language ? DashboardTracker.language : ''
    };

    if (seek) {
      operator = { ...operator, ...seek };
    }

    return operator;
  };

  getLanguage(options) {
    if (!options) {
      return '';
    }

    for (let i = 0; i < options.length; i++) {
      if (options[i].is_current) {
        return options[i].label_short;
      }
    }
    return '';
  }

  getDashboardInfo(operatorKey, status = 1, content = null, seek = null) {
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'DashboardTracker[getDashboardInfo');

    return {
      time: this.getTime(),
      user: this.getUser(),
      application: APPLICATION_PARAMS,
      device: DEVICE_PARAMS,
      servername: this.getServerName(),
      cdn: this.getCdn(),
      operator: this.getOperator(operatorKey, {
        status,
        content,
        seek,
        subRegion: DeviceStorage.getItem('sub_region') || false,
        soaVersion: DeviceStorage.getItem('soaVersion') || false,
        epgVersion: DeviceStorage.getItem('epgVersion') || false
      })
    };
  }

  getDashboardInfoEpg(operatorKey, status = 1, content) {
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'DashboardTracker[getDashboardInfoEpg]');

    return {
      time: this.getTime(),
      user: this.getUser(),
      application: APPLICATION_PARAMS,
      device: DEVICE_PARAMS,
      servername: this.getServerName(),
      cdn: this.getCdn(),
      operator: this.getOperatorEpg(operatorKey, {
        status,
        content,
        subRegion: DeviceStorage.getItem('sub_region') || false,
        soaVersion: DeviceStorage.getItem('soaVersion') || false,
        epgVersion: DeviceStorage.getItem('epgVersion') || false
      })
    };
  }

  async track(operatorKey, status = 1, content = null, seek = null) {
    try {
      logger.debug('[DashboardTracker] track init');
      const log = this.getDashboardInfo(operatorKey, status, content, seek);
      const url =
        LOGS_DASHBOARD_URL === 'logs_dashboard_url'
          ? Metadata.get('logs_dashboard_url', null)
          : LOGS_DASHBOARD_URL;
      logger.debug('[DashboardTracker] track url', url);
      if (!url) {
        return;
      } // must not send the request on empty url
      const { headers } = this;
      const body = { logs: [log] };
      // console.info("DashboardTracker dashboardTask", dashboardTask);
      const dashboardTask = new SimplePostRequestTask({
        url,
        headers: {},
        params: body,
        showErrorModal: false
      });
      await RequestManager.addRequest(dashboardTask);
      logger.debug('[DashboardTracker] track end');
    } catch (e) {
      logger.error('[DashboardTracker] err', e);
    }
  }

  async trackEpg(operatorKey, status, content) {
    const url =
      LOGS_DASHBOARD_URL === 'logs_dashboard_url'
        ? Metadata.get('logs_dashboard_url', null)
        : LOGS_DASHBOARD_URL;

    const log = this.getDashboardInfoEpg(operatorKey, status, content);
    // const log = {epgTest:msg}
    const body = { logs: [log] };
    const dashboardTask = new SimplePostRequestTask({
      url,
      headers: {},
      params: body,
      showErrorModal: false
    });
    await RequestManager.addRequest(dashboardTask);
  }
}

export default DashboardTracker;



// WEBPACK FOOTER //
// ./src/utils/trackers/DashboardTracker.js